import styled from "styled-components";
import { Modal as Base } from "@sablier/v2-components/organisms";
import { useModalDetails } from "~/client/hooks";
import Body from "./Body";

const Modal = styled(Base.List)``;

function Details() {
  const { id } = useModalDetails();

  return (
    <Modal id={id} title={`Details`}>
      <Body />
    </Modal>
  );
}

export default Details;
